var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchEvents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8659 20.5253C8.0198 20.5253 5.60952 19.5382 3.63508 17.564C1.66091 15.5896 0.673828 13.1793 0.673828 10.3332C0.673828 7.48709 1.66091 5.07681 3.63508 3.10236C5.60952 1.1282 8.0198 0.141113 10.8659 0.141113C13.712 0.141113 16.1223 1.1282 18.0967 3.10236C20.0709 5.07681 21.058 7.48709 21.058 10.3332C21.058 11.5235 20.8583 12.6603 20.4588 13.7436C20.0591 14.8269 19.5259 15.7692 18.8592 16.5703L28.4492 26.1603C28.6801 26.3908 28.7981 26.6808 28.8034 27.0303C28.8087 27.3797 28.6906 27.6751 28.4492 27.9165C28.2079 28.1579 27.9151 28.2786 27.5709 28.2786C27.227 28.2786 26.9344 28.1579 26.693 27.9165L17.103 18.3265C16.2697 19.0146 15.3113 19.5531 14.228 19.9419C13.1447 20.3308 12.024 20.5253 10.8659 20.5253ZM10.8659 18.0257C13.0134 18.0257 14.8323 17.2804 16.3226 15.7899C17.8131 14.2996 18.5584 12.4807 18.5584 10.3332C18.5584 8.1857 17.8131 6.36681 16.3226 4.87653C14.8323 3.38597 13.0134 2.6407 10.8659 2.6407C8.71841 2.6407 6.89952 3.38597 5.40924 4.87653C3.91869 6.36681 3.17341 8.1857 3.17341 10.3332C3.17341 12.4807 3.91869 14.2996 5.40924 15.7899C6.89952 17.2804 8.71841 18.0257 10.8659 18.0257Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEvents);
export default __webpack_public_path__ + "static/media/searchEvents.ff3cded50c71d515cb7ee5595e9193eb.svg";
export { ForwardRef as ReactComponent };